
// const hideValues = false

import ApiService from './ApiService'
import LocalStorageService from './LocalStorageService'

class FormService {

  getSubmissions = async (apiToken, params, where, body) => {
    var url = '/api/formsubmission'

    // var params = {
    //   fields: 'id,user,organisation,reference,type',
    //   limit: 1000
    // }

    if (where) {
      params.where = where
    }

    try {
      // Need to change this to a POST
      var submissions = await ApiService.get(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return submissions
  }

  getResponses = async (apiToken, params, where) => {
    var url = '/api/formresponse'

    if (where) {
      params.where = where
    }

    // var params = {
    //   fields: 'id,user,organisation,submission,questionKey,questionText,response',
    //   limit: 1000
    // }

    try {
      var responses = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return responses
  }

  makeSubmissions = async (apiToken, data) => {
    var url = '/api/formsubmission'

    var params = {}

    var body = {
      data: data
    }

    try {
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  updateSubmission = async (apiToken, id, data) => {
    var url = `/api/formsubmission/${id}`

    var params = {}

    var body = {
      data: data
    }

    try {
      var response = await ApiService.put(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  updateClickerDate = async (apiToken, id, data) => {
    var url = `/api/formresponse/${id}/clicker-date`

    var params = {}

    var body = {
      data: data
    }

    try {
      var response = await ApiService.put(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
      throw err
    }
    return response
  }

  getComments = async (apiToken, submissionId) => {
    var url = `/api/formsubmission/${submissionId}/comment`

    var params = {}
    try {
      var response = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  addComment = async (apiToken, submissionId, content, section = 'general') => {
    var url = `/api/formsubmission/${submissionId}/comment`

    var params = {
      section: section
    }

    var body = {
      content: content
    }

    try {
      var response = await ApiService.post(apiToken, url, params, body)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  deleteComment = async (apiToken, submissionId, commentId) => {
    var url = `/api/formsubmission/${submissionId}/comment/${commentId}`

    var params = {}

    try {
      var response = await ApiService.sendDelete(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  pushIncidentToCpoms = async (apiToken, submissionId) => {
    var url = `/api/formsubmission/${submissionId}/cpoms/push`
    var params = {}
    try {
      var response = await ApiService.post(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return response
  }

  getCommonLocations = async (apiToken) => {
    var url = `/api/formsubmission/locations`
    var params = {}
    try {
      var response = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return response?.locations || []
  }

  createConcern = async (studentId, data) => {

    const currentUser = LocalStorageService.get('userDetails')
    const activeOrg = LocalStorageService.get('activeOrg')
    const apiToken = LocalStorageService.get('apiToken')

    let responses = [
      {
        questionKey: 'student',
        questionText: 'Student',
        response: studentId
      },
      {
        questionKey: 'recordedBy',
        questionText: 'Recorded By',
        response: String(currentUser.id)
      },
      {
        questionKey: 'concernDate',
        questionText: 'Concern Date',
        response: new Date().toISOString().split('T')[0]
       },
       {
        questionKey: 'concernTime',
        questionText: 'Concern Time',
        response: new Date().toISOString().split('T')[1].split('.')[0]
      }
    ]

    if (data.positiveNegative) {
      responses.push({
        questionKey: 'positiveNegative',
        questionText: 'Positive or Negative',
        response: data.positiveNegative
      })
    }

    if (data.concern) {
      responses.push({
        questionKey: 'concern',
        questionText: 'Concern',
        response: data.concern
      })
    }

    const requestData = {
      user: currentUser.id,
      organisation: activeOrg.id,
      status: 'Published',
      type: 'concern',
      reference: '',
      responses: responses,
      subject: studentId
    }

    try {
      var response = await this.makeSubmissions(apiToken, requestData)
    } catch (err) {
      console.error(err)
    }

    return response
  }

  createMessage = async (studentId, message = '') => {

    const currentUser = LocalStorageService.get('userDetails')
    const activeOrg = LocalStorageService.get('activeOrg')
    const apiToken = LocalStorageService.get('apiToken')

    let responses = [
      {
        questionKey: 'student',
        questionText: 'Student',
        response: studentId
      },
      {
        questionKey: 'recordedBy',
        questionText: 'Recorded By',
        response: String(currentUser.id)
      },
      {
        questionKey: 'messageDate',
        questionText: 'Message Date',
        response: new Date().toISOString().split('T')[0]
       },
       {
        questionKey: 'messageTime',
        questionText: 'Message Time',
        response: new Date().toISOString().split('T')[1].split('.')[0]
      },
      {
        questionKey: 'message',
        questionText: 'Message',
        response: message
      }
    ]

    const requestData = {
      user: currentUser.id,
      organisation: activeOrg.id,
      status: 'Published',
      type: 'message',
      reference: '',
      responses: responses,
      subject: studentId
    }

    try {
      var response = await this.makeSubmissions(apiToken, requestData)
    } catch (err) {
      console.error(err)
    }

    return response
  }

}
export default new FormService()
